import { SiteService } from './../../../services/site/site.service';
import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IOSAndamento, ISite } from 'src/app/interfaces';
import { IAutorizacoes } from 'src/app/interfaces/token/IAutorizacoes';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ListaPaginada } from 'src/app/models';
import { AuthenticationService, OSService } from 'src/app/services';
import { FiltroGenericoComponent } from 'src/app/components/filtro-generico/filtro-generico.component';

@Component({
  selector: 'app-listar-historico-chamados',
  templateUrl: './listar-historico-chamados.component.html',
  styleUrls: ['./listar-historico-chamados.component.scss']
})
export class ListarHistoricoChamadosComponent implements OnInit, OnDestroy {
  @ViewChild(FiltroGenericoComponent) filtroGenerico: FiltroGenericoComponent;
  filtraForm!: FormGroup;
  subscriptions$ = new Subscription();
  pageSize = 5;
  chamados = new ListaPaginada<IOSAndamento>();
  page = 1;
  permissoes: IToken;
  autorizacoes: IAutorizacoes;
  token = this.authService.obterToken();
  filterData: any;
  sitesOptions = new ListaPaginada<ISite>();
  // Permissoes

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authService.obterToken()['autorizacoes'];
  }

  constructor(
    private fb: FormBuilder,
    private service: OSService,
    private authService: AuthenticationService,
    private router: Router,
    private siteService: SiteService
  ) {}

  //#region Controle filtro genérico
  exibirSite(site: ISite) {
    return `${site.codSite} | ${site.nome}`;
  }
  valorSite(site: ISite) {
    return site.codSite;
  }
  //#endregion

  ngOnInit() {
    this.getUserPermissoes();
    this.getSite();
    this.filtraForm = this.fb.group({
      FiltroPesquisar: [''],
      codigoOS: [''],
      site: ['']
    });

    this.getHistoricoChamados();
    this.gerenciarPermissoesTela();
    if (!this.autorizacoes.listarChamadosAndamento) {
      this.router.navigateByUrl('/historico-chamados/finalizados');
    }
  }
  receiveFilterData(filterData: any) {
    this.filterData = filterData;
  }

  getSite() {
    this.subscriptions$.add(
      this.siteService
        .getSite({
          paginar: false,
          TipoUsuario: this.token.tipoUsuario,
          codContrato: this.token.codContrato,
          CodGrupoEconomico: this.token.codGrupoEconomico
        })
        .subscribe({
          next: ({ data }) => {
            this.sitesOptions = data;
          }
        })
    );
  }

  getHistoricoChamados(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.chamados.paginaAtual = 1;
    }

    this.subscriptions$.add(
      this.service
        .getOSAndamento({
          IdUsuario: this.token.id,
          CodSite: this.filterData?.site ?? '',
          NumSerie: this.filterData?.numserie ?? '',
          NumPat: this.filterData?.patrimonio ?? '',
          CodContrato: this.filterData?.contrato ?? this.permissoes.codContrato,
          FiltroPesquisar: this.filtraForm.get('FiltroPesquisar')?.value,
          CodGrupoEconomico: this.permissoes.codGrupoEconomico,
          paginaAtual: this.chamados.paginaAtual,
          itensPorPagina: this.chamados.itensPorPagina
        })
        .subscribe({
          next: ({ data }) => {
            this.chamados = data;
            this.filtroGenerico?.hidePopUp();
          }
        })
    );
  }

  getUserPermissoes() {
    this.permissoes = this.authService.obterToken();
    this.autorizacoes = this.permissoes.autorizacoes;
  }

  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
  }
}
